<template>
  <div>
    <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
    </alertaMensaje>
    <v-container>
      <v-row v-if="verFormulario">
        <v-col cols="12" align-self="center">
          <ButtonComp @click="regresarComp()" text-button="Volver" icon-but="fas fa-arrow-alt-circle-left" normal-button
            class-color="red" />
        </v-col>
        <v-col cols="12">
          <v-row class="d-flex justify-center">
            <v-col cols="6" md="3">
              <v-text-field dense readonly v-model="parametros.items.item.desc_nivel" label="NIVEL"
                type="text"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly
                v-model="parametros.items.item.desc_grado" label="GRADO" type="text"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly v-model="parametros.items.item.desc_area"
                label="ÁREA" type="text"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly
                v-model="parametros.items.item.desc_curso" label="CURSO" type="text"></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <div>
            <v-container fluid>
              <v-row>
                <v-col cols="6" class=" ">
                  <!-- <label class="ml-2 grey--text">Dificultad:</label> -->
                  <v-radio-group v-model="dificultadCheckbox" label="Dificultad:" class="mt-0" hide-details>
                    <div class="d-flex">
                      <v-radio color="green" value="0" class="mr-3">
                        <template v-slot:label>
                          <strong class="success--text">Baja</strong>
                        </template>
                      </v-radio>
                      <v-radio color="blue" value="1" class="mr-3">
                        <template v-slot:label>
                          <strong class="primary--text">Media</strong>
                        </template>
                      </v-radio>
                      <v-radio color="red" value="2" class="mr-3">
                        <template v-slot:label>
                          <strong class="error--text">Alta</strong>
                        </template>
                      </v-radio>
                      <v-radio class="d-none"></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>

                <v-col cols="6" class="d-flex align-end">
                  <v-select v-model="tipo_pregunta" @change="cambiarTipoRespuesta(tipo_pregunta)"
                    :items="itemTiposPreguntas" label="Seleccionar tipo de pregunta" chips :hint="tipo_pregunta.text"
                    persistent-hint></v-select>
                </v-col>

                <v-col cols="12" class="py-0">
                  <v-alert border="left" dense color="primary" dark elevation="10">
                    <!-- <v-divider class="pt-3 mt-3"></v-divider> -->
                    <!-- <h2 class="pa-0">CREACIÓN DE PREGUNTAS Y RESPUESTAS</h2> -->
                    <div class="text-center pa-2">
                      Unidad:
                      <span style="font-weight: 300">
                        {{ parametros.items.item.nombre_tema }}
                      </span>

                      <br />
                      Tema:
                      <span style="font-weight: 300">
                        {{ parametros.items.item.nombre_clase }}
                      </span>
                    </div>
                    <!-- <h5>Implementa tus preguntas</h5> -->

                    <!-- <v-btn class="mx-2" fab dark x-small color="green-blue darken-4">
                        <v-icon dark> mdi-format-paint </v-icon>
                      </v-btn> -->
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-alert border="left" dense color="success" outlined dark elevation="10" class="text-center">
                    <v-row align="center">
                      <v-col cols="4" offset-md="4">
                        <h2>Formula tu pregunta</h2>
                      </v-col>
                      <v-col class="shrink text-end" cols="4">
                        <v-btn @click="guardarPreguntaBtn" dark small color="orange">
                          <v-icon dark class="pr-1">
                            {{ doingPregunta ? ' mdi-check' : 'mdi-pencil' }}
                          </v-icon>
                          {{ doingPregunta ? 'Guardar' : 'Editar' }}
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-alert>
                </v-col>
                <v-col cols="12" v-if="doingPregunta" class="py-0 my-0 text-center">
                  <ckeditor :key="'pregunta-editor'" class="classEditor" @input="validaTextAreaPregunta"
                    tag-name="textarea" v-model="textarea_pregunta" :config="editorConfig">
                  </ckeditor>


                </v-col>
                <v-col v-if="!doingPregunta" cols="12">
                  <div class="pa-4" style="background: #eaeaea; text-align: center">
                    <h2 v-html="textarea_pregunta"></h2>
                  </div>
                </v-col>

                <v-col cols="12" class="" v-if="!doingPregunta">
                  <div style="text-align: center">
                    <v-alert border="left" dense color="primary" outlined dark elevation="10">


                      <v-row align="center">
                        <v-col cols="4" offset-md="4">
                          <h4>Ingresa tus respuestas</h4>
                        </v-col>
                        <v-col class="shrink text-end" cols="4">
                          <template>
                            <v-btn @click="agregarRespuesta(textarea_respuesta)" dark small color="primary"
                              :disabled="rptaDisabled">
                              <v-icon dark class="pr-1">mdi mdi-plus</v-icon>
                              Guardar
                            </v-btn>
                          </template>
                        </v-col>
                      </v-row>

                    </v-alert>
                  </div>
                </v-col>
                <!-- autofocus -->
                <v-col cols="12" v-if="!doingPregunta" class="py-0 my-0 text-center">

                  <ckeditor :key="'respuesta-editor'" @input="validaTextAreaRespuesta" tag-name="textarea"
                    v-model="textarea_respuesta" :config="editorConfigRspta2"></ckeditor>

                  <v-textarea style="visibility: hidden; position: absolute;" @keydown.enter.exact.prevent
                    @keyup.enter.exact="agregarRespuesta(textarea_respuesta)"
                    @keydown.enter.shift.exact="nuevaLineaTxArea" @keyup="validaTextAreaRespuesta" ref="textareaResp"
                    prepend-icon="mdi-comment" color="green darken-3" v-model="textarea_respuesta" filled auto-grow
                    label="* ESCRIBE UNA RESPUESTA" rows="3" row-height="20" shaped
                    :disabled="rptaDisabled"></v-textarea>

                </v-col>

                <v-col cols="12" class="py-0 text-center text-subtitle-1">
                  <div>
                    <br>
                    <span v-if="!doingPregunta"> <strong>Alternativas</strong> </span>
                    <span v-if="tipo_pregunta == 'res_uni'"> <strong>/ Selección única</strong> </span>
                    <span v-if="tipo_pregunta == 'res_mul'"> <strong>/ Selección múltiple</strong> </span>
                    <span v-if="tipo_pregunta == 'ver_fal'"><strong> : Selección V / F</strong> </span>
                  </div>
                </v-col>

                <v-col cols="12">
                  <!-- RESPUESTAS DINAMICAS LOOP O BLUCE FOREACH -->
                  <v-alert v-for="(respta, i) in coleccionRespuestas" :key="i" :type="coloresValidos[i] || 'error'"
                    prominent dense>
                    <v-row align="center">
                      <v-col class="grow" v-html="respta">
                      </v-col>
                      <v-col class="shrink d-flex">
                        <!-- RESPUESTA UNICA -->
                        <div v-if="tipo_pregunta == 'res_uni'" class="mt-1 pt-1">
                          <v-radio-group class="mr-2 mt-2 pt-0" v-model="radioButtonRstpaUnica[i]"
                            @change="radioButtonCorrecto($event, i, true)">
                            <v-radio style="margin-top: -2px" :value="i"> </v-radio>
                          </v-radio-group>
                        </div>
                        <!-- RESPUESTA MULTIPLE -->
                        <div v-if="tipo_pregunta == 'res_mul'" class="mt-1 pt-1">
                          <!-- @click.native="checkBoxCorrecto" -->
                          <v-checkbox @change="checkBoxCorrecto($event, i)" v-model="checkboxesRespuestas[i]"
                            :ripple="true" style="margin: 2px 10px" hide-details></v-checkbox>
                        </div>
                        <!-- RESPUESTA V o F -->
                        <div v-if="tipo_pregunta == 'ver_fal'" class="mt-1 pt-1">
                          <v-radio-group class="mr-2 mt-2 pt-0" v-model="radioButtonRstpaUnica[i]"
                            @change="radioButtonCorrecto($event, i, true)">
                            <v-radio style="margin-top: -2px" :value="i"> </v-radio>
                          </v-radio-group>
                          <!-- <v-btn-toggle
                            style="margin-top: -2px"
                            v-model="vf_value[i]"
                            
                            group
                            @change="vf_change($event, i)"
                          >
                            <v-btn value="V"> <strong>V</strong> </v-btn>

                            <v-btn value="F"> <strong>F</strong> </v-btn>
                          </v-btn-toggle> -->
                        </div>

                        <v-btn @click="editarRespuesta(i)" class="ma-2"
                          :disabled="tipo_pregunta == 'ver_fal' ? true : false" text icon color="grey darken-4">
                          <v-icon> mdi-square-edit-outline</v-icon>
                        </v-btn>
                        <v-btn @click="eliminarRespuesta(i)" :disabled="tipo_pregunta == 'ver_fal' ? true : false"
                          class="ma-2" text icon color="grey darken-4">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>

        <!-- <v-btn @click="testmostrar" depressed color="warning" small>
          test
        </v-btn> -->

        <v-col cols="12" class="text-center" v-if="btnguardar">
          <v-btn :loading="loadingbtnGuardar" :disabled="loadingbtnGuardar" class="btn_block_style2 ma-2 white--text"
            @click="guardarPreguntaDB">
            Guardar cambios
            <!-- {{ btnguardarTitle }} -->
            <!-- <v-icon right dark> mdi-database </v-icon> -->
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModalF()">
    </component>
  </div>
</template>

<script>
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import axios from '@/helpers/axios';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
// import { mapState, mapMutations } from "vuex";
export default {
  name: 'formularioPregunta',
  props: {
    parametros: {
      type: Object
    },
    estadoComp: {
      type: Boolean
    }
  },
  components: {
    ButtonComp,
    alertaMensaje: () => import('../../components/Co-alertaMensaje.vue'),
    listaPreguntas: () => import('./listaPreguntas.vue')
  },
  data: () => ({
    editorConfig: {
      on: {
        instanceReady: function (ev) {
          setTimeout(function () {
            ev.editor.focus();
          }, 100);
        }
      },
      extraPlugins: 'ckeditor_wiris',
      embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
      mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
      protectedSource: [/<u[^>]><\/u>/g],
      disallowedContent: 'script; *[on*]; *[style*]',
      allowedContent: true,
      extraAllowedContent: 'math[xmlns]; maction; maligngroup; malignmark; menclose; merror; mfenced; mfrac; mglyph; mi;' +
        'mlabeledtr; mlogdiv; mmultiscripts; mn; mo; mover; mpadded; mphantom; mroot; mrow; ms; mscarries; mscarry;' +
        'msgroup; mstack; msline; mspace; msqrt; msrow; mstack; mstyle; msub; msup; msubsup; mtable; mtd; mtext; mtr;' +
        'munder; munderover; semantics; annotation; annotation-xml;',
      toolbar: [
        ['ckeditor_wiris_formulaEditor', 'ckeditor_wiris_formulaEditorChemistry'],
        ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'],
        ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
        ['Find', 'Replace', '-', 'SelectAll', 'RemoveFormat'],
        ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
        ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'],
        ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
        ['Link', 'Unlink', 'Anchor'],
        ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'],
        ['Styles', 'Format', 'Font', 'FontSize'],
        ['TextColor', 'BGColor']
      ],
      height: 100,
    },
    editorConfigRspta2: {
      on: {
        instanceReady: function (ev) {
          setTimeout(function () {
            ev.editor.focus();
          }, 100);
        }
      },
      extraPlugins: 'ckeditor_wiris',
      embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
      mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
      protectedSource: [/<u[^>]><\/u>/g],
      disallowedContent: 'script; *[on*]; *[style*]',
      allowedContent: true,
      extraAllowedContent: 'math[xmlns]; maction; maligngroup; malignmark; menclose; merror; mfenced; mfrac; mglyph; mi;' +
        'mlabeledtr; mlogdiv; mmultiscripts; mn; mo; mover; mpadded; mphantom; mroot; mrow; ms; mscarries; mscarry;' +
        'msgroup; mstack; msline; mspace; msqrt; msrow; mstack; mstyle; msub; msup; msubsup; mtable; mtd; mtext; mtr;' +
        'munder; munderover; semantics; annotation; annotation-xml;',
      toolbar: [
        ['ckeditor_wiris_formulaEditor', 'ckeditor_wiris_formulaEditorChemistry'],
        ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'],
        ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
        ['Find', 'Replace', '-', 'SelectAll', 'RemoveFormat'],
        ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
        ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'],
        ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
        ['Link', 'Unlink', 'Anchor'],
        ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'],
        ['Styles', 'Format', 'Font', 'FontSize'],
        ['TextColor', 'BGColor']
      ],
      height: 100
    },
    alertRespuestas: '',
    btnguardar: false,
    snackbarAlerta: false,
    Alertatext: '',
    timeout: 2000,

    rptaDisabled: false,
    // objetoReplicaTemas: [],
    idtema: '',
    select_nivel: '',
    select_grado: '',
    select_area: '',
    select_curso: '',

    loadingbtnGuardar: false,
    idpreguntaValida: null,
    itemTiposPreguntas: [
      { text: 'Respuesta única', value: 'res_uni' },
      { text: 'Respuesta múltiple', value: 'res_mul' },
      { text: 'Verdadero o falso', value: 'ver_fal' }
    ],

    radioButtonRstpaUnica: [],
    // Variables de alerta
    mostrarSnackbar: false,
    mensajeAlerta: '',

    // Variable de AlertConfim
    mostrarDialogConfirm: false,
    validaDialogConfirm: false,
    mensajeDialog: '',

    // radioButtonRstpaUnica: null,
    vf_value: [],

    totalPag: null,
    snackbarOrden: false,
    colorsnackbarOrden: 'green',
    textAlertOrden: '',

    doingPregunta: false,
    preguntaHecha: false,
    btnAgregaPregunta: false,
    btnAgregaRespuesta: false,

    respuestaHecha: false,
    textarea_respuesta: '',
    textarea_pregunta: '',
    textarea_pregunta2: '',
    idrespuestaIndex: '',
    doingRespuesta: false,
    tituloBotonAgregaEdita: 'Agrega respuestas',
    estadoAgregaEdita: 0, //0 agrega 1 edita

    // tipo_pregunta: "res_uni",
    tipo_pregunta: "",

    dificultadCheckbox: "0",
    idclase: null,
    coleccionRespuestas: [],

    arrayPreguntasYrespuestas: [],
    arrayRespuestasPorPreguntas: [],
    arrayBalotarioDeleted: [], //Array de id Balotario
    arrayPreguntaDeleted: [], //Array de id Preguntas
    objetoDetalleRespuesta: [],
    coloresValidos: [],
    checkboxesRespuestas: [],
    color: 'error',
    datoLogin: sessionStorage,

    compName: null,
    estadoComponente: null,
    parametroComp: [],
    verFormulario: true,
    objeto: {}
  }),
  methods: {
    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },
    guardarPreguntaBtn() {

      const me = this;

      if (me.textarea_pregunta == '') {
        // si le dió a guardar pero no escribió nada
        alert('Por favor redacte una pregunta.');
        return;
      }
      me.doingPregunta = !me.doingPregunta;


      if (me.doingPregunta) {
        me.preguntaHecha = false;


        console.log('working about', this.textarea_pregunta2);
        

        setTimeout(() => {
          this.textarea_pregunta = this.textarea_pregunta2;
        }, 1000);


      } else {
        this.textarea_pregunta2 = this.textarea_pregunta
        me.preguntaHecha = true;
      }


      me.textarea_respuesta = ''

    },

    abrirTextareaRespuesta() {
      const me = this;

      if (!me.preguntaHecha) {
        me.snackbarOrden = true;
        me.colorsnackbarOrden = 'red';
        me.textAlertOrden = 'Ingresa una Pregunta previamente';

        return false;
      }

      me.doingRespuesta = !me.doingRespuesta;

      if (me.doingRespuesta == true) {
        me.respuestaHecha = false;
      } else {
        me.respuestaHecha = true;
      }
    },
    agregarRespuesta(rpsta) {
      const me = this;

      if (me.textarea_respuesta != '' && me.tipo_pregunta != '') {
        me.textarea_respuesta = '';
        me.respuestaHecha = true;
        me.$refs.textareaResp.focus();

        if (me.estadoAgregaEdita == 1) {
          me.coleccionRespuestas[me.idrespuestaIndex] = rpsta;
          me.objetoDetalleRespuesta[me.idrespuestaIndex].descripcion = rpsta; //Nuevo Valor en Objeto a Editar
          me.estadoAgregaEdita = 0;
          me.tituloBotonAgregaEdita = 'Agrega respuesta';

        } else {

          const idpregunta =
            me.idpreguntaValida == '' && me.idpreguntaValida == null ? '' : me.idpreguntaValida;

          console.log(idpregunta);

          const objtCrea = {
            valor_respuesta: false,
            descripcion: rpsta,
            orden: 0,
            idpregunta: idpregunta,
            estado: true
          };
          me.objetoDetalleRespuesta.push(objtCrea);
          me.coleccionRespuestas.push(rpsta);
        }

      } else if (me.textarea_respuesta == '') {
        alert('Escribe una respuesta');
      } else if (me.tipo_pregunta == "") {
        alert('Selecciona un tipo de pregunta');
      }
    },
    editarRespuesta(i) {
      const me = this;


      console.log('asdasdasdasdsa', me.coleccionRespuestas[i]);
      

      me.idrespuestaIndex = i;
      me.tituloBotonAgregaEdita = 'Edita respuesta';
      me.estadoAgregaEdita = 1;
      me.textarea_respuesta = me.coleccionRespuestas[i]; //+ 'indice '+ i
    },
    eliminarRespuesta(i) {
      const me = this;
      console.log(me.radioButtonRstpaUnica);
      console.log(me.coloresValidos);
      me.coleccionRespuestas.splice(i, 1);
      me.objetoDetalleRespuesta.splice(i, 1);
      me.coloresValidos.splice(i, 1);
      // CHECKBOX UNICO, MULTIPLE, VERDADERO Y FALSO.
      me.vf_value.splice(i, 1);
      me.checkboxesRespuestas.splice(i, 1);
      me.radioButtonRstpaUnica.splice(i, 1);
      // me.radioButtonRstpaUnica[i] = i;

      let indexFind = me.coloresValidos.indexOf('success');
      me.radioButtonRstpaUnica[indexFind] = indexFind;

      console.log(indexFind);

      // me.hideBotones();
    },
    validaTextAreaPregunta() {
      const me = this;
      if (me.textarea_pregunta == '') {
        me.btnAgregaPregunta = false;
      } else {
        me.btnAgregaPregunta = true;
      }
    },
    validaTextAreaRespuesta() {
      const me = this;
      if (me.textarea_respuesta == '') {
        me.btnAgregaRespuesta = false;
      } else {
        me.btnAgregaRespuesta = true;
      }
    },
    cambiarTipoRespuesta(valor) {
      const me = this;

      me.radioButtonRstpaUnica = [];
      me.coleccionRespuestas = [];
      me.objetoDetalleRespuesta = [];
      me.doingRespuesta = true;

      console.log(valor);
      me.coloresValidos = [];
      me.checkboxesRespuestas = [];
      me.vf_value = [];

      if (valor == 'ver_fal') {
        me.doingRespuesta = false;
        me.rptaDisabled = true;

        let VerdaderFalso = ['VERDADERO', 'FALSO'];

        const idpregunta =
          me.idpreguntaValida == '' && me.idpreguntaValida == null ? '' : me.idpreguntaValida;

        for (let i = 0; i < VerdaderFalso.length; i++) {
          me.objetoDetalleRespuesta.push({
            valor_respuesta: false,
            descripcion: VerdaderFalso[i],
            orden: 0,
            idpregunta: idpregunta,
            estado: true
          });

          me.coleccionRespuestas.push(VerdaderFalso[i]);
        }
      } else {
        me.coleccionRespuestas = [];
        me.rptaDisabled = false;
      }
    },
    radioButtonCorrecto(checked, i, flag) {
      const me = this;
      me.radioButtonRstpaUnica = [];
      me.radioButtonRstpaUnica[i] = checked;

      me.objetoDetalleRespuesta[i].valor_respuesta = [];
      for (let o = 0; o < me.objetoDetalleRespuesta.length; o++) {
        if (i == o) {
          me.objetoDetalleRespuesta[o].valor_respuesta = flag;
        } else {
          me.objetoDetalleRespuesta[o].valor_respuesta = false;
        }
      }

      me.coloresValidos = [];
      me.coloresValidos[checked] = 'success';
    },
    checkBoxCorrecto(checked, i) {
      const me = this;

      console.log(me.objetoDetalleRespuesta[i].valor_respuesta);
      console.log(i);

      if (checked) {
        me.coloresValidos[i] = 'success';
        me.objetoDetalleRespuesta[i].valor_respuesta = true;
      } else {
        me.coloresValidos[i] = 'error';
        me.objetoDetalleRespuesta[i].valor_respuesta = false;
      }
    },
    async guardarPreguntaDB() {
      const me = this;

      // const hasTrueValue = me.objetoDetalleRespuesta.some(
      //   (obj) => Object.values(obj)[0] === true
      // );

      // if (!hasTrueValue) {
      //   alert("Por favor Selecciona una respuesta");
      //   return false;
      // }

      if (me.doingPregunta == true) {
        alert('Por favor agrega la pregunta');
        return false;
      }

      // CREAR PREGUNTA Y RESPUETAS
      if (me.idpreguntaValida == '' || me.idpreguntaValida == null) {
        try {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();
          me.loadingbtnGuardar = true;
          const respuesta = await axios.post(
            '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/registra',
            {
              descripcion_balotario: 'BALOTARIO' + me.parametros.items.item.id_clase,
              descripcion: me.textarea_pregunta,
              tipo_pregunta: me.tipo_pregunta,
              orden: me.parametros.cantidad.length + 1,
              nivel: me.dificultadCheckbox,
              idtema: me.parametros.items.item.id_clase,
              respuestas: me.objetoDetalleRespuesta
            }
          );
          if (respuesta.status == '200') {
            NProgress.done();
            me.loadingbtnGuardar = false;
            me.btnAgregaPregunta = false;
            me.btnguardar = false;
            me.mostrarSnackbar = true;
            me.mensajeAlerta = 'Pregunta registrada satisfactoriamente';
            me.idpreguntaValida == '';
          }
          me.limpiarPreguntas();
          me.$emit('close');
        } catch (error) {
          console.log(error);
        }
        // EDITAR PREGUNTA Y RESPUETAS
      } else {
        try {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();
          me.loadingbtnGuardar = true;
          const respuesta = await axios.put(
            '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/actualiza/' +
            me.idpreguntaValida,
            {
              descripcion_balotario: 'BALOTARIO' + me.parametros.item.idclase,
              descripcion: me.textarea_pregunta,
              tipo_pregunta: me.tipo_pregunta,
              orden: me.ordenPregunta,
              nivel: me.dificultadCheckbox,
              idtema: me.parametros.item.idclase,
              respuestas: me.objetoDetalleRespuesta
            }
          );

          console.log(me.objetoDetalleRespuesta);
          console.log(respuesta);

          if (respuesta.status == '200') {
            NProgress.done();
            me.loadingbtnGuardar = false;
            me.btnAgregaPregunta = false;
            me.btnguardar = false;
            me.mostrarSnackbar = true;
            me.mensajeAlerta = 'Pregunta actualizada satisfactoriamente';
            me.idpreguntaValida == '';
          }
          me.limpiarPreguntas();
          me.$emit('close');
        } catch (error) {
          console.log(error);
        }
      }
    },
    agregaPreguntaVista() {
      const me = this;
      me.doingPregunta = false;
      me.preguntaHecha = true;
      me.doingRespuesta = true;
      // me.$refs.textareaResp.focus();
    },
    CloseModalF() {
      const me = this;
      me.estadoComponente = false;
      me.verFormulario = false;
    },
    limpiarPreguntas() {
      const me = this;
      me.idpreguntaValida = "";
      // me.tipo_pregunta = "res_uni";
      me.tipo_pregunta = "";
      me.textarea_pregunta = "";
      me.dificultadCheckbox = "0";
      me.idclase = null;
      me.coleccionRespuestas = [];
      me.objetoDetalleRespuesta = [];
      me.coloresValidos = [];
      me.checkboxesRespuestas = [];
      me.radioButtonRstpaUnica = [];
      me.vf_value = [];
      me.doingPregunta = true;
      me.preguntaHecha = false;
      me.btnAgregaPregunta = false;
      me.btnAgregaRespuesta = false;
    },
    /*----------------------------------------*/
    /* LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    /*----------------------------------------*/
    async listarRespuestaPorPregunta(items) {
      const me = this;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      try {
        const response = await axios.get(
          '/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listarespreg/' +
          items.idpregunta
        );
        me.textarea_respuesta = '';
        me.arrayRespuestasPorPreguntas = response.data;
        console.log(items.tema);

        setTimeout(async () => {
          NProgress.done();
        }, 800);

        me.arrayRespuestasPorPreguntas.forEach((element, index) => {
          me.coleccionRespuestas.push(element.respuesta);
          const objtEdita = {
            idrespuesta: element.idrespuesta,
            valor_respuesta: element.valor_respuesta,
            descripcion: element.respuesta,
            orden: 0,
            idpregunta: items.idpregunta,
            estado: true
          };
          me.objetoDetalleRespuesta.push(objtEdita);

          switch (items.tipo) {
            case 'res_uni':
              if (objtEdita.valor_respuesta) {
                me.radioButtonRstpaUnica[index] = index;
                me.coloresValidos[index] = 'success';
              }
              break;

            case 'res_mul':
              if (objtEdita.valor_respuesta) {
                me.checkboxesRespuestas[index] = objtEdita.valor_respuesta;
                me.coloresValidos[index] = 'success';
              }

              break;

            case 'ver_fal':
              if (objtEdita.valor_respuesta) {
                me.radioButtonRstpaUnica[index] = index;
                me.coloresValidos[index] = 'success';
              }
              break;

            default:
              break;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    regresarComp() {
      this.objeto = {};
      this.limpiarPreguntas();
      this.$emit('close');
    },
    async init() {
      const me = this;
      me.verFormulario = true;

      if (me.parametros.event == 'view_gestor') {
        me.limpiarPreguntas();
      } else {
        me.btnguardar = true;
        me.preguntaHecha = true;
        me.doingPregunta = false;
        me.textarea_pregunta = this.parametros.item.titulo;
        me.textarea_pregunta2 = this.parametros.item.titulo;
        me.ordenPregunta = this.parametros.item.orden;
        me.idpreguntaValida = this.parametros.item.idpregunta;
        me.tipo_pregunta = this.parametros.item.tipo;
        me.doingRespuesta = false;
        switch (this.parametros.item.tipo) {
          case 'ver_fal':
            me.doingRespuesta = false;
            me.rptaDisabled = true;
            break;

          case 'res_uni':
            me.doingRespuesta = true;
            me.rptaDisabled = false;
            break;

          case 'res_mul':
            me.doingRespuesta = true;
            me.rptaDisabled = false;
            break;
        }

        me.dificultadCheckbox = this.parametros.item.dificultad.toString();
        await me.listarRespuestaPorPregunta(this.parametros.item);
      }
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.init();
      } else {
        this.verFormulario = false;
      }
    },
    coleccionRespuestas(e) {
      if (e.length != 0) {
        this.btnguardar = true;
      } else {
        this.btnguardar = false;
      }
    }
  }
};
</script>

<style>
.cke_button__ckeditor_wiris_formulaeditor .cke_button_icon {
  background-image: url('/ckeditor/icons/formula.png') !important;

}

.cke_button__ckeditor_wiris_formulaeditorchemistry .cke_button_icon {
  background-image: url('/ckeditor/icons/chem.png') !important;
}


.classEditor {
  display: flex;
  justify-content: space-around;
}

/* div.cke_notifications_area {
  display: none;
} */
</style>
